"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContextualMenu_1 = require("office-ui-fabric-react/lib/ContextualMenu");
var DashboardLayoutRegistry_1 = require("./DashboardLayoutRegistry");
var onClickDashboardLayoutItem = function (e, item) {
    item.applyLayout(item.dashboard);
};
var createDashboardLayoutMenuItem = function (dashboard, item) {
    return {
        key: item.key,
        name: item.name,
        iconProps: item.iconProps,
        dashboard: dashboard,
        applyLayout: item.applyLayout,
        canCheck: true,
        checked: item.isLayoutApplied(dashboard),
        onClick: onClickDashboardLayoutItem
    };
};
exports.createDashboardLayoutMenuItem = createDashboardLayoutMenuItem;
var createDashboardLayoutMenuItems = function (dashboard, items) {
    if (items === void 0) { items = DashboardLayoutRegistry_1.DashboardLayoutRegistry.itemsView; }
    var isAnyLayoutApplied = items.some(function (item) { return item.isLayoutApplied(dashboard); });
    var r = items.map(function (item) {
        return createDashboardLayoutMenuItem(dashboard, item);
    });
    r.push({
        dashboard: dashboard,
        key: "other",
        name: "Custom",
        iconProps: { iconName: "ViewDashboard" },
        checked: !isAnyLayoutApplied,
        canCheck: true,
        disabled: true
    });
    return r;
};
exports.createDashboardLayoutMenuItems = createDashboardLayoutMenuItems;
var createDashboardLayoutMenuSection = function (dashboard, items) {
    if (items === void 0) { items = DashboardLayoutRegistry_1.DashboardLayoutRegistry.itemsView; }
    var layoutItems = createDashboardLayoutMenuItems(dashboard, items);
    return {
        key: "layoutSectionItem",
        itemType: ContextualMenu_1.ContextualMenuItemType.Section,
        sectionProps: {
            key: "layoutSection",
            title: "Layout",
            items: layoutItems
        }
    };
};
exports.createDashboardLayoutMenuSection = createDashboardLayoutMenuSection;
var createDashboardMenu = function (dashboard, items) {
    if (items === void 0) { items = DashboardLayoutRegistry_1.DashboardLayoutRegistry.itemsView; }
    var layoutSectionItem = createDashboardLayoutMenuSection(dashboard, items);
    var current = layoutSectionItem.sectionProps.items.find(function (item) { return item.checked; });
    return {
        key: "dashboardLayout",
        name: dashboard.sync.syncing ? "Loading..." : dashboard.sync.error ? "Error" : current ? current.name : "Layout",
        iconProps: current ? current.iconProps : { iconName: "ViewDashboard" },
        subMenuProps: {
            items: [layoutSectionItem]
        }
    };
};
exports.createDashboardMenu = createDashboardMenu;
var createDashboardSettingsItem = function (name, dashboard, items) {
    if (items === void 0) { items = DashboardLayoutRegistry_1.DashboardLayoutRegistry.itemsView; }
    var layoutSectionItem = createDashboardLayoutMenuSection(dashboard, items);
    return {
        key: "dashboardSettings",
        name: name,
        iconProps: { iconName: "Settings" },
        subMenuProps: {
            items: [layoutSectionItem]
        }
    };
};
exports.createDashboardSettingsItem = createDashboardSettingsItem;
var createDashboardListMenu = function (dashboardList, items) {
    if (items === void 0) { items = DashboardLayoutRegistry_1.DashboardLayoutRegistry.itemsView; }
    var sync = dashboardList.sync;
    var active = dashboardList.active;
    return !sync.syncing && active ? createDashboardMenu(active, items) : undefined;
};
exports.createDashboardListMenu = createDashboardListMenu;
